<template>
  <div>
    <nav-breadcrumb :menu="[{label: ' 意向进件'}]"/>
    <el-tabs v-model="applicationStatus">
      <el-tab-pane label="待审核" name="Pending Approval" />
      <!-- <el-tab-pane label="审核通过" name="Approved" />-->
      <el-tab-pane label="不予授信进件" name="Rejected" />
    </el-tabs>
    <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "CustomerApplyingList",
        data(){
          return{
            applicationStatus: 'Pending Approval',
            roleData:{},
            dealerOptions:[],
            tableData: {
              count: 0,
              data: []
            },
            dealerTypeOptions:[],
            page: 1,
            pageSize: 20,
            actions: [
              /*{
                label: '新增',
                class: 'el-icon-plus',
                clickHandler: ()=>{
                  this.$router.push({
                    path: 'add'
                  })
                }
              }*/
            ],
            filters: {
              labelWidth: '150px',
              form: {
                ba__customerName:'',
                ba__customerContactNo:'',
                ba__customerIC:'',
                d__dealerId:'',
                t__applicationDate:[],
              },
              columns: [
                {
                  label: '客户姓名',
                  component: 'el-input',
                  field: 'ba__customerName'
                },
               /* {
                  label: '客户手机号',
                  component: 'el-input',
                  field: 'ba__customerContactNo'
                },*/
                {
                  label: '身份证号码',
                  component: 'el-input',
                  field: 'ba__customerIC'
                },
                {
                  label: '渠道商',
                  component: 'el-select',
                  field: 'd__dealerId',
                  options:this.dealerOptions,
                  span: 12
                },
                {
                  label: '进件日期',
                  component: 'date-range-picker',
                  field: 't__applicationDate',
                  op: ['gteq', 'lteq'],
                  span: 12
                },



              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
        },
        computed:{
          columns: function(){
            return [
              {
                type: 'index'
              },
              {
                label: '客户姓名',
                field: 'ba__customerName'
              },
             /* {
                label: '手机号',
                field: 'ba__customerContactNo'
              },*/
              {
                label: '身份证号码',
                field: 'ba__customerIC'
              },
              {
                label: '渠道商',
                field: 'd__dealerName'
              },
             /* {
                label: '客户来源',
                field: 'ba__channel'
              },*/
              {
                label: '进件时间',
                field: 't__applicationDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD HH:mm')
                }
              },
              {
                label: '状态',
                field: 't__applicationStatus',
                formatter: function (r,c,v) {
                  return Status2CN(v)
                }
              },
                {
                    label: '当前待审批节点',
                    field: 't__nodeName',
                    formatter: function (r,c,v) {
                        if(r.t__applicationStatus=='Rejected'){
                            v=''
                        }
                        return v
                    }
                },
              {
                label: '操作',
                opts:[
                  {
                    label: '查看',
                    class: 'el-icon-view',
                    clickHandler: (index, row) => {
                      this.$router.push({
                        name: 'CustomerApplyingDetailView',
                        query: {
                          'applicationId': row.t__applicationId,
                        }
                      })
                    },
                  },
                  {
                    label: '重新发起',
                    class: 'el-icon-refresh-right',
                    clickHandler: (index, row) => {
                      this.$confirm('是否确认重新发起！')
                        .then(()=> {
                          xhr.ReInitApplyingCustomer(
                            {
                              't.applicationId': row.t__applicationId,
                            },
                            res=> {
                              try{
                                if(res.data.status == 'success') {
                                  this.getData()
                                }else{
                                  this.$message.error(res.data.msgs[0].text)
                                }

                              }catch (e) {

                                this.$message.error(error.msgs[0].text)

                              }
                            }
                          )
                        })
                        .catch(()=> {

                        })

                    },
                    conditions: row=> {
                      return row.t__applicationStatus=='Rejected'

                    }
                  },

                  {
                      label: row=> {
                          let name  = '审核';
                          (this.tableData.variables.procInfo||[]).forEach(item=>{
                              if(item.code=='JJSP'&&item.roleId==row.t__roleId){
                                  name = item.name
                              }
                          })

                          return name
                      },
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                          if(row.t__nodeType=='XMSQR')
                             this.approveCustomerKF(index, row)
                          else
                              this.approveCustomer(index, row)
                    },
                    conditions: row=> {
                      return row.t__hasRole == 'true'&&row.t__applicationStatus=='Pending Approval'

                    }
                  },
                  /*  {
                        label: '业务负责人',
                        class: 'el-icon-success',
                        clickHandler: (index, row) => {
                            this.approveCustomer(index, row)
                        },
                        conditions: row=> {
                            return row.t__hasRole == 'true' && row.t__roleId==this.roleData.r0a&&row.t__applicationStatus=='Pending Approval'

                        }
                    },
                  {
                    label: '风控审核',
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.approveCustomer(index, row)
                    },
                    conditions: row=> {
                      return row.t__hasRole == 'true' && row.t__roleId==this.roleData.r1&&row.t__applicationStatus=='Pending Approval'

                    }
                  },

                    {
                        label: '副总审核',
                        class: 'el-icon-success',
                        clickHandler: (index, row) => {
                            this.approveCustomer(index, row)
                        },
                        conditions: row=> {
                            return row.t__hasRole == 'true' && row.t__roleId==this.roleData.r1a&&row.t__applicationStatus=='Pending Approval'

                        }
                    },
                  {
                    label: '总经理审核',
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.approveCustomer(index, row)
                    },
                    conditions: row=> {
                      return row.t__hasRole == 'true' && row.t__roleId==this.roleData.r2&&row.t__applicationStatus=='Pending Approval'

                    }
                  },

                  {
                    label: '审核&授信(董事长)',
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.approveCustomer(index, row)
                    },
                    conditions: row=> {
                      return row.t__hasRole == 'true' && row.t__roleId==this.roleData.r3&&row.t__applicationStatus=='Pending Approval'

                    }
                  },
                  {
                    label: '审核&授信(终审)',
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.approveCustomer(index, row)
                    },
                    conditions: row=> {
                      return row.t__hasRole == 'true' && row.t__roleId==this.roleData.r4&&row.t__applicationStatus=='Pending Approval'

                    }
                  },*/

                  {
                    label: '发起贷款申请',
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.$router.push({
                        name: 'FinancingAddView',
                        query: {
                          'applicationId': row.t__applicationId,
                          /* 'creditId': row.cr__creditId || ''*/
                        }
                      })
                    },
                    conditions: row=> {
                      return row.t__applicationStatus=='Approved'

                    }
                  },
                    {
                        label: '撤回',
                        class: ' el-icon-back',
                        clickHandler: (index, row) => {
                            this.$confirm('是否确认撤回进件？一旦撤回，审核人将无法再审核','撤回进件')
                                .then(()=> {
                                    xhr.RevokeApprovingCustomer(
                                        {
                                            't.applicationId': row.t__applicationId,
                                        },
                                        res=> {
                                            try{
                                                if(res.data.status == 'success') {
                                                    this.getData()
                                                }else{
                                                    this.$message.error(res.data.msgs[0].text)
                                                }

                                            }catch (e) {

                                                this.$message.error(error.msgs[0].text)

                                            }
                                        }
                                    )
                                })
                                .catch(()=> {

                                })
                        },
                        conditions: row=> {
                            return row.t__applicationStatus==='Pending Approval'&&this.tableData.variables.procInfo.length>0&&row.t__roleId!==this.tableData.variables.procInfo[0].roleId&&this.$store.state.userInfo.detail.find(item=> item.ur__roleId === this.tableData.variables.procInfo[0].roleId )

                        }
                    },
                ]
              }
            ]
          },
          filterParams: {
            get: function() {
              return {
                pageSize: this.pageSize,
                pageOffset: (this.page - 1) * this.pageSize,
                'xlist.search.t.applicationStatus' : this.applicationStatus,
                'xlist.search.t.applicationStatus.op' : 'in',
                'xlist.sort.dataField': 't.applicationDate',
                'xlist.sort.order': 'desc'
              }
            },
            set:function (newVal) {

            }
          }
        },
        watch: {
          filterParams: function () {
            this.getData()
          },
        },

        mounted() {
          this.getData()
          this.getDealerList()
        },
        methods: {
          getData: function () {
            xhr.getApplyingCustomerFangList(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res => {
                try {
                  this.tableData = res.data
                  this.roleData = res.data.variables
                    this.tableData.data.forEach(item=>{
                        item.t__nodeName = (this.tableData.variables.procInfo.find(item2=> item2.type ===item.t__nodeType )||{}).name


                    })
                } catch (e) {

                }
              })
          },
          getDealerList: function () {
            xhr.getDealerList(
              Object.assign({pageSize:0}, {}, {}),
              res=> {
                try {
                  this.filters.columns[2].options = res.data.data.map(item=>{
                    return {
                      label: item.d__dealerName,
                      value:item.d__dealerId,
                    }
                  })
                }catch(e){

                }
              })

          },

          approveCustomerKF: function (index, row) {
            this.$router.push({
              name: 'CustomerApplyingFangApproveKF',
              query: {
                'applicationId': row.t__applicationId,
               /* 'creditId': row.cr__creditId || ''*/
              }
            })
          },
          approveCustomer: function (index, row) {
            this.$router.push({
              name: 'CustomerApplyingFangApprove',
              query: {
                'applicationId': row.t__applicationId,
                'role1':this.roleData.r1,
                /* 'creditId': row.cr__creditId || ''*/
              }
            })
          },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplyingList.vue